"use strict"

import StudentAssignmentFeedback from "../../model/domain/student-assignment-feedback"
import StudentAssignmentOverview from "../../model/domain/student-assignment-overview"
import StudentAssignmentWork from "../../model/domain/student-assignment-work"
import AssignmentWorkService from "../assignment-work/assignment-work.service"
import CacheService from "../cache/cache.service"
import AssignmentTrackingService from "../assignment-tracking/assignment-tracking.service"
import BreadcrumbService from "../breadcrumb-service/breadcrumb.service"
import StorageService from "../storage/storage.service"
import StudentCacheService from "../student-cache/student-cache.service"
import ToolbarService from "../toolbar/toolbar.service"
import ExportService from "../export/export.service"
import FeedbackService from "../feedback/feedback.service"
import PlatformHeaderService from "../platform/platform-header.service"
import ClassCodeService from "../class-code/class-code.service"

/**
 * This service creates StudentAssignment* objects in a way that can be mocked in tests
 */
export default class StudentAssignmentService {
  /**
   * @ngInject
   * @param {AssignmentWorkService} AssignmentWorkService
   * @param {CacheService} CacheService
   * @param {AssignmentTrackingService} AssignmentTrackingService
   * @param {BreadcrumbService} BreadcrumbService
   * @param {StorageService} StorageService
   * @param {StudentCacheService} StudentCacheService
   * @param {ToolbarService} ToolbarService
   * @param {ExportService} ExportService
   * @param {FeedbackService} FeedbackService
   * @param {PlatformHeaderService} PlatformHeaderService
   * @param {ClassCodeService} ClassCodeService
   */
  constructor(
    $q,
    $timeout,
    $state,
    $stateParams,
    $mdDialog,
    AssignmentWorkService,
    CacheService,
    AssignmentTrackingService,
    BreadcrumbService,
    StorageService,
    StudentCacheService,
    ToolbarService,
    ExportService,
    FeedbackService,
    PlatformHeaderService,
    ClassCodeService,
  ) {
    this.$q = $q
    this.$timeout = $timeout
    this.$state = $state
    this.$stateParams = $stateParams
    this.$mdDialog = $mdDialog

    /** @type {AssignmentWorkService} */
    this._assignmentWorkService = AssignmentWorkService
    /** @type {CacheService} */
    this._cacheService = CacheService
    /** @type {AssignmentTrackingService} */
    this._assignmentTrackingService = AssignmentTrackingService
    /** @type {BreadcrumbService} */
    this._breadcrumbService = BreadcrumbService
    /** @type {StorageService} */
    this._storageService = StorageService
    /** @type {StudentCacheService} */
    this._studentCacheService = StudentCacheService
    /** @type {ToolbarService} */
    this._toolbarService = ToolbarService
    /** @type {ExportService} */
    this._exportService = ExportService
    /** @type {FeedbackService} */
    this._feedbackService = FeedbackService
    /** @type {PlatformHeaderService} */
    this._platformHeaderService = PlatformHeaderService
    /** @type {ClassCodeService} */
    this._classCodeService = ClassCodeService
  }

  /**
   * @return {StudentAssignmentFeedback}
   */
  getStudentAssignmentFeedback() {
    return new StudentAssignmentFeedback(
      this.$q,
      this.$timeout,
      this.$stateParams,
      this._assignmentWorkService,
      this._cacheService,
      this._assignmentTrackingService,
      this._breadcrumbService,
      this._storageService,
      this._studentCacheService,
      this._toolbarService,
      this._feedbackService,
    )
  }

  /**
   * @param helpInboxType {string}
   * @return {StudentAssignmentOverview}
   */
  getStudentAssignmentOverview(helpInboxType) {
    return new StudentAssignmentOverview(
      this.$timeout,
      this.$state,
      this.$stateParams,
      this.$mdDialog,
      this._studentCacheService,
      this._cacheService,
      this._breadcrumbService,
      this._exportService,
      this._platformHeaderService,
      helpInboxType,
    )
  }

  /**
   * @param helpInboxType {string}
   * @param [pager] {PageTraverser}
   * @return {StudentAssignmentWork}
   */
  getStudentAssignmentWork(helpInboxType, pager) {
    return new StudentAssignmentWork(
      this.$timeout,
      this.$state,
      this.$mdDialog,
      this._studentCacheService,
      this._assignmentTrackingService,
      this._cacheService,
      this._assignmentWorkService,
      this._exportService,
      this._feedbackService,
      this._platformHeaderService,
      this._classCodeService,
      helpInboxType,
      pager,
    )
  }
}
